<tt-page *ngIf="page" class="col-xs-12 sp-0 height-full">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-6 p-5">
            <tt-input ttLabel="prod_id" [ttModel]="page.prod_id" ttReadonly></tt-input>
            <tt-input ttLabel="prod_name" [ttModel]="page.prod_name" ttReadonly></tt-input>
        </tt-card>
        <tt-card class="col-xs-12 col-md-6 p-5">
            <tt-input-number ttLabel="quantity_topick" [ttModel]="page.quantity_topick" ttTextAlign="right" ttDecimals="2" ttFormatNumber ttReadonly></tt-input-number>
            <tt-input-number ttLabel="quantity_picked" [ttModel]="page.quantity_picked" ttTextAlign="right" ttDecimals="2" ttFormatNumber ttReadonly></tt-input-number>
            <tt-input-number ttLabel="quantity_rest" [ttModel]="page.quantity_rest" ttTextAlign="right" ttDecimals="2" ttFormatNumber ttReadonly></tt-input-number>
        </tt-card>
    </div>
    <tt-button-save ttText="consignmentlineassign_complete_pick" (ttClick)="saveChanges()" [ttLoading]="saving" [ttDisabled]="loading || !grid?.gridfunc" ttTextAlign="center"></tt-button-save>
    <tt-grid *ngIf="grid" [(ttOptions)]="grid"></tt-grid>
</tt-page>
